export var createMuiListSubheaderOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        gutters: {
            paddingLeft: spacing(2),
            paddingRight: spacing(2),
        },
    });
};
//# sourceMappingURL=MuiListSubheader.js.map